import { useEffect, useState } from "react";
import { supabase } from "@/integrations/supabase/client";
import { stripDocIdPrefix } from "@/lib/docTitle";

/**
 * Cached doc_id -> member-facing title map. Used at the display layer so
 * internal reference codes can be swapped for real titles before anything
 * renders to a member.
 */
let cache: Record<string, string> | null = null;
let pending: Promise<Record<string, string>> | null = null;

export function loadDocTitles(): Promise<Record<string, string>> {
  if (cache) return Promise.resolve(cache);
  if (!pending) {
    pending = (async () => {
      const { data } = await supabase
        .from("sop_documents" as any)
        .select("doc_id,title")
        .eq("status", "published");
      const map: Record<string, string> = {};
      for (const r of (data as any[]) || []) {
        map[r.doc_id] = stripDocIdPrefix(r.title);
      }
      cache = map;
      return map;
    })();
  }
  return pending;
}

export function useDocTitles(): Record<string, string> {
  const [titles, setTitles] = useState<Record<string, string>>(cache || {});
  useEffect(() => {
    let alive = true;
    loadDocTitles().then((m) => {
      if (alive) setTitles(m);
    });
    return () => {
      alive = false;
    };
  }, []);
  return titles;
}
